import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserResponseDTO } from '../model/user-response-dto';

@Injectable({
  providedIn: 'root'
})
export class ResumeService {

  baseUrl:string;

  constructor(private http:HttpClient) {
    this.baseUrl = environment.baseUrl;
   }


   getUserData(userKey:string){
    return this.http.get<UserResponseDTO>(`${this.baseUrl}/cv/userInfoCv?idCvUser=${userKey}`);
   }
}
